var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstribo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 4.5,
    fill: "white",
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7663 44.4397C20.7778 44.4397 21.5696 44.8659 22.1418 45.7183C22.7139 46.5651 23 47.7282 23 49.2075C23 50.7308 22.7037 51.9103 22.1111 52.7462C21.5236 53.5821 20.7216 54 19.705 54C18.6986 54 17.9093 53.6068 17.3372 52.8204H17.1762L16.7854 53.835H15V41H17.3372V43.986C17.3372 44.3655 17.3065 44.9731 17.2452 45.809H17.3372C17.8838 44.8962 18.6935 44.4397 19.7663 44.4397ZM19.0153 46.4524C18.4381 46.4524 18.0166 46.6449 17.751 47.0298C17.4853 47.4093 17.3474 48.0389 17.3372 48.9188V49.191C17.3372 50.1808 17.4725 50.8902 17.7433 51.3192C18.0192 51.7481 18.4534 51.9626 19.046 51.9626C19.5262 51.9626 19.9068 51.7261 20.1877 51.2532C20.4738 50.7747 20.6169 50.0819 20.6169 49.1745C20.6169 48.2671 20.4738 47.588 20.1877 47.1371C19.9017 46.6806 19.5109 46.4524 19.0153 46.4524Z",
    fill: "#005AE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2909 72.8277L54.8175 71.5185H54.7533C54.3414 72.0755 53.9161 72.4631 53.4774 72.6813C53.0441 72.8938 52.4771 73 51.7763 73C50.9151 73 50.2357 72.7359 49.7382 72.2076C49.2461 71.6793 49 70.9271 49 69.9509C49 68.9288 49.3317 68.1766 49.995 67.6942C50.6637 67.2061 51.6693 66.9363 53.012 66.8846L54.5687 66.8329V66.4109C54.5687 65.4347 54.1033 64.9466 53.1725 64.9466C52.4557 64.9466 51.6132 65.1792 50.6449 65.6443L49.8345 63.8699C50.8669 63.29 52.0117 63 53.2688 63C54.4724 63 55.3952 63.2814 56.0371 63.8441C56.679 64.4068 57 65.2624 57 66.4109V72.8277H55.2909ZM54.5687 68.3661L53.6219 68.4005C52.9104 68.4235 52.3808 68.5613 52.0331 68.814C51.6854 69.0666 51.5115 69.4513 51.5115 69.9681C51.5115 70.7089 51.9074 71.0792 52.6991 71.0792C53.2661 71.0792 53.7182 70.9041 54.0552 70.5538C54.3975 70.2036 54.5687 69.7384 54.5687 69.1585V68.3661Z",
    fill: "#008746"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78 42H36.4142L39.7071 45.2929C40.0976 45.6834 40.0976 46.3166 39.7071 46.7071C39.3166 47.0976 38.6834 47.0976 38.2929 46.7071L33.5858 42H30V44.5858L35.2071 49.7929C35.5976 50.1834 35.5976 50.8166 35.2071 51.2071C34.8166 51.5976 34.1834 51.5976 33.7929 51.2071L30 47.4142V57H78V42ZM30 39H27V42V57V60H30H78H81V57V42V39H78H30Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstribo);
export default __webpack_public_path__ + "static/media/estribo.aa59c487c1934504f8e49e6e787b84d5.svg";
export { ForwardRef as ReactComponent };